import React from 'react'
import {
  TextField,
  SearchInput,
  SelectInput,
  NumberField,
  ReferenceField,
} from 'react-admin'

import Datagrid from '../common/Datagrid'
import RecordSplitButton from '../common/buttons/RecordSplitButton'
import List from '../common/views/List'
import { directoryTypeChoices, industryTypeChoices } from './constants'

const leadDirectoryFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput source="industry" choices={industryTypeChoices} alwaysOn />,
  <SelectInput source="type" choices={directoryTypeChoices} alwaysOn />,
]

const LeadDirectoryList = (props) => (
  <List
    {...props}
    filters={leadDirectoryFilters}
    sort={{ field: 'id', order: 'DESC' }}
  >
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <TextField source="name" label="Name" />
      <TextField source="site" label="Site" />
      <TextField source="industry" label="Industry" />
      <TextField source="type" label="Type" />
      <NumberField source="estimated_leads_count" label="Est. Leads" />
      <ReferenceField
        source="recommended_campaign_id"
        reference="campaigns"
        label="Campaign"
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <RecordSplitButton />
    </Datagrid>
  </List>
)

export default LeadDirectoryList
